var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8959 7.34289C20.7279 7.60989 16.5919 13.9679 11.424 12.3325C8.20798 11.3145 5.99199 12.3492 5 13V3.07086C6.63199 2.89564 9.72798 2.90398 12.344 4.81472C16.0719 7.5348 20.1999 6.40004 20.2399 6.3917C20.4799 6.3166 20.7439 6.41673 20.8879 6.62532C21.0319 6.84226 21.0399 7.12595 20.8959 7.34289Z",
    fill: "#91172C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.83333V21.1667C5 21.625 4.55 22 4 22C3.45 22 3 21.625 3 21.1667V2.83333C3 2.375 3.45 2 4 2C4.55 2 5 2.375 5 2.83333Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedflag);
export default __webpack_public_path__ + "static/media/redflag.9295a7121ce4b760c0eac8f2a14d2bbb.svg";
export { ForwardRef as ReactComponent };